angular.module('cn')

.component('modalconfirm', {
  template: require('./modalconfirm.html'),
  bindings: {
    resolve: '<',
    close: '&'
  }
});



// WEBPACK FOOTER //
// ./src/lib/modalconfirm.js